import { render, staticRenderFns } from "./HsOfficeStudentsView.vue?vue&type=template&id=723fa76b&"
import script from "./HsOfficeStudentsView.vue?vue&type=script&lang=js&"
export * from "./HsOfficeStudentsView.vue?vue&type=script&lang=js&"
import style0 from "./HsOfficeStudentsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports